export function Baidu(code = '', hostname = '') {
  // 仅统计生产环境数据
  if (process.env.NODE_ENV !== 'production' && hostname !== 'localhost') return;
  // 如果指定域名
  if (hostname && location.hostname != hostname) return;
  // 百度统计代码code
  if (!code) return;
  var _hmt = _hmt || [];
  (function () {
    var hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?' + code;
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(hm, s);
  })();
}
